import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { chatbotApi } from '../../../common/src';
import { toast } from 'react-toastify';
import moment from 'moment';

const WidgetGoodOrderList = (props) => {
  const { loginId, pkg } = props;
  const [list, setList] = useState(null);
  const param = props.childProps.payload.param;
  //console.log(param);
  //   const preText = props.childProps.state.prevMessage;
  //   const _prev = () => {
  //     props.childProps.actionProvider._categoryPrev(preText);
  //   };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _more = () => {};
  const _goMy = (orderCode) => {
    window.open(
      `https://shop.aniplustv.com/mypage/order/detail?orderCode=${orderCode}`,
      '',
      ''
    );
  };
  const _deliveryinfo = (orderCode, SaleType, goodSerial, deliverySate) => {
    props.childProps.actionProvider._deliveryMsg(
      orderCode,
      SaleType,
      goodSerial,
      deliverySate
    );
  };
  const _cancelInfo = (
    orderCode,
    SaleType,
    goodSerial,
    deliverySate,
    saelEnd,
    goodTotalPrice
  ) => {
    props.childProps.actionProvider._cancelMsg(
      orderCode,
      SaleType,
      goodSerial,
      deliverySate,
      saelEnd,
      goodTotalPrice
    );
  };

  const _returnInfo = (
    orderCode,
    SaleType,
    goodSerial,
    deliverySate,
    saelEnd,
    goodTotalPrice
  ) => {
    props.childProps.actionProvider._returnMsg(
      orderCode,
      SaleType,
      goodSerial,
      deliverySate,
      saelEnd,
      goodTotalPrice
    );
  };
  const getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  const _getData = async () => {
    // const at = localStorage.getItem('at');
    const at = getCookie('at');
    let result;
    if (loginId === undefined || loginId === null || loginId === '') {
      toast.warn('로그인후 이용 가능한 서비스입니다.');
    } else {
      if (param === 'goodReturn') {
        result = await axios.post(
          chatbotApi + '/api/getGoodReturnList',
          {
            userid: loginId,
            pkg: pkg,
          },
          {
            headers: {
              Authorization: 'bearer ' + at,
            },
          }
        );
      } else {
        result = await axios.post(
          chatbotApi + '/api/getGoodOrderList',
          {
            userid: loginId,
            pkg: pkg,
          },
          {
            headers: {
              Authorization: 'bearer ' + at,
            },
          }
        );
      }

      //   //console.log(result);

      const intReturn = result.data.intReturn;
      //console.log(intReturn);
      //console.log(result.data.listData);
      if (intReturn === 0) {
        setList(result.data.listData);
      }
    }
  };
  const _addComma = (price) => {
    let returnString = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return returnString;
  };
  useEffect(() => {
    _getData();
  }, []);
  return (
    <>
      <div className="order-container">
        <div>
          <h1>주문내역</h1>
        </div>
        <div className="order-info">
          <div>
            <table>
              <thead>
                <tr>
                  <th>상품명</th>
                  {/* <th>결제금액</th>
                  <th>구분</th> */}
                </tr>
              </thead>
              <tbody>
                {list ? (
                  list.map((item) => (
                    <tr>
                      <td>
                        <span>[주문번호: {item.orderCode}]</span>
                        <br />
                        {item.goodTitle}{' '}
                        {item.cnt > 1 ? ` 외 ${item.cnt - 1}건` : null}
                        <br />
                        <em>결제 금액: {_addComma(item.sumPrice)}원</em>
                        <br />
                        <em>
                          결제일:{' '}
                          {moment(item.regDate).format('YYYY.MM.DD hh:mm')}
                        </em>
                        <br />
                        <em>배송상태: {item.deliverySate}</em>
                        <div className="order-info-btn">
                          {param === 'delivery' ? (
                            <div
                              className="btn-delivery"
                              onClick={() =>
                                _deliveryinfo(
                                  item.orderCode,
                                  item.SaleType,
                                  item.goodSerial,
                                  item.deliverySate
                                )
                              }
                            >
                              배송일 확인
                            </div>
                          ) : param === 'orderCancel' ? (
                            <div
                              className="btn-delivery"
                              onClick={() =>
                                _cancelInfo(
                                  item.orderCode,
                                  item.SaleType,
                                  item.goodSerial,
                                  item.deliverySate,
                                  item.saleEnd,
                                  item.goodTotalPrice
                                )
                              }
                            >
                              주문취소 절차
                            </div>
                          ) : (
                            <div
                              className="btn-delivery"
                              onClick={() =>
                                _returnInfo(
                                  item.orderCode,
                                  item.SaleType,
                                  item.goodSerial,
                                  item.deliverySate,
                                  item.saleEnd,
                                  item.goodTotalPrice
                                )
                              }
                            >
                              반품 절차
                            </div>
                          )}

                          {/* <div
                            className="btn-list"
                            onClick={() => _goMy(item.orderCode)}
                          >
                            결제내역 확인
                          </div> */}
                        </div>
                      </td>
                      {/* <td>{item.sumPrice}</td>
                      <td>환불/취소</td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>구매 내역이 존지하지 않습니다.</td>
                  </tr>
                )}
                {/* <div className="refund-info">
                  결제일 기준 만 7일 이내, 환불 및 결제 취소가 가능합니다.
                  <br />
                  <br />
                  상품 취소를 원하시는 경우 애니플러스 쇼핑 페이지 - 해당 상품
                  상세 페이지의 '상품문의'로 문의주시면 안내를 도와드리고
                  있습니다.
                  <br />
                  <br />
                  -예약 기간 및 결제 수단에 따라 위약금이 발생할 수 있습니다.
                </div> */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="prev-chat-container" style={{ paddingTop: 10 }}>
        <div className="prev-contaner">
          <div onClick={_more} className="prev">
            <img src="/img/chatbot/icon_cart.png" />
            주문/배송 자세히 보기
          </div>

          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default shopContext(withRouter(WidgetGoodOrderList));
